module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("ALSO BY MICHAEL TOLKIN")])]), _vm._v(" "), _c('p', {
    staticClass: "textcenter"
  }, [_c('em', [_vm._v("The Return of the Player"), _c('br'), _vm._v("Among the Dead"), _c('br'), _vm._v("Under Radar"), _c('br'), _vm._v("Three Screenplays: The Player,"), _c('br'), _vm._v("The Rapture, The New Age")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-979764c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm03_also.vue
// module id = 63
// module chunks = 0